import axios from 'axios';
import { config } from '../../config';
import { adminAuthHeaders } from './authHeaders';

// Manages who has admin access. Server-side, these calls are locked to the
// 'admin' role tier — a 'coordinator' or 'viewer' caller gets a 403.

export async function getAdminAccounts() {
    const host = `${config.service.host}/api/admin`;
    const headers = await adminAuthHeaders();
    const { data } = await axios.get(`${host}/admin-accounts`, {
        headers,
    });
    return data;
}

export async function grantAdminRole(email, role) {
    const host = `${config.service.host}/api/admin`;
    const headers = await adminAuthHeaders();
    const { data } = await axios.post(`${host}/admin-accounts`, { email, role }, {
        headers,
    });
    return data;
}

export async function revokeAdminRole(uid) {
    const host = `${config.service.host}/api/admin`;
    const headers = await adminAuthHeaders();
    const { data } = await axios.delete(`${host}/admin-accounts/${uid}`, {
        headers,
    });
    return data;
}
